<template>
  <div class="c-creative">
    <div class="c-creative-wrapper g-clearfix">
      <div v-for="(item, id) in data" :key="id" :class="creativeClasses(item)">
        <creat-video
          v-if="item.element_type === 'ELEMENT_TYPE_VIDEO'"
          v-model="item.videoid"
          :name="item.name"
          :type="item.element_type"
          :width="item.restriction.video_restriction.width"
          :height="item.restriction.video_restriction.height"
          :size="item.restriction.video_restriction.file_size"
          :format="item.restriction.video_restriction.file_format"
          :source="source"
          :required="item.required"
          :verify="verify"
          :description="item.description"
          @on-change="retVerify"
          @on-select="selectMedia"
          @on-upload="uploadFileComplet"
        >
        </creat-video>
        <creat-image
          v-if="item.element_type === 'ELEMENT_TYPE_IMAGE'"
          v-model="item[item.name]"
          :name="item.name"
          :type="item.element_type"
          :width="item.restriction.image_restriction.width"
          :height="item.restriction.image_restriction.height"
          :size="item.restriction.image_restriction.file_size"
          :format="item.restriction.image_restriction.file_format"
          :required="item.required"
          :verify="verify"
          :description="item.description"
          @on-change="retVerify"
          @on-select="selectMedia"
          @on-upload="uploadFileComplet"
        >
        </creat-image>
        <!-- 数组类型 -->
        <template v-if="item.element_type === 'ELEMENT_TYPE_STRUCT'">
          <div v-for="(met, idx) in item.children" :key="idx" :class="creativeClasses(met)">
            <creat-image
              v-if="item.field_type === 'FIELD_TYPE_STRUCT_ARRAY' && met.element_type === 'ELEMENT_TYPE_IMAGE'"
              v-model="met[met.name]"
              :name="met.name"
              :type="met.element_type"
              :width="met.restriction.image_restriction.width"
              :height="met.restriction.image_restriction.height"
              :size="met.restriction.image_restriction.file_size"
              :format="met.restriction.image_restriction.file_format"
              :source="source"
              :required="met.required"
              :verify="verify"
              :description="met.description"
              @on-change="retVerify"
              @on-select="selectMedia"
              @on-upload="uploadFileComplet"
            >
            </creat-image>
          </div>
        </template>
        <creat-title
          v-if="item.name === 'title'"
          v-model="item[item.name]"
          :name="item.name"
          :min="item.restriction.text_restriction.min_length"
          :max="item.restriction.text_restriction.max_length"
          :required="item.required"
          :pattern="item.restriction.text_restriction.text_pattern"
          :verify="verify"
          :description="item.description"
          @on-change="retVerify"
        >
        </creat-title>
        <creat-icon
          v-if="item.element_type === 'ELEMENT_TYPE_ICON'"
          v-model="item[item.name]"
          :name="item.name"
          :type="item.element_type"
          :width="item.restriction.image_restriction.width"
          :height="item.restriction.image_restriction.height"
          :size="item.restriction.image_restriction.file_size"
          :format="item.restriction.image_restriction.file_format"
          :required="item.required"
          :verify="verify"
          :description="item.description"
          @on-change="retVerify"
          @on-upload="uploadFileComplet"
        >
        </creat-icon>
        <creat-text
          v-if="item.element_type === 'ELEMENT_TYPE_TEXT' && item.name !== 'title'"
          v-model="item[item.name]"
          :name="item.name"
          :min="item.restriction.text_restriction.min_length"
          :max="item.restriction.text_restriction.max_length"
          :required="item.required"
          :pattern="item.restriction.text_restriction.text_pattern"
          :verify="verify"
          :description="item.description"
          @on-change="retVerify"
        >
        </creat-text>
        <creat-url
          v-if="item.element_type === 'ELEMENT_TYPE_URL'"
          v-model="item[item.name]"
          :name="item.name"
          :min="item.restriction.text_restriction.min_length"
          :max="item.restriction.text_restriction.max_length"
          :required="item.required"
          :default="item.enum_property.default"
          :pattern="item.restriction.text_restriction.text_pattern"
          :verify="verify"
          :description="item.description"
          @on-change="retVerify"
        >
        </creat-url>
      </div>
    </div>
    <!-- 选择素材 -->
    <!-- 20241109去掉素材选择弹窗组件 -->
    <!-- <uploader v-model="uploadModel" :type="uploadType" :width="uploadWidth" :height="uploadHeight" @on-upload="uploadFileHandle"></uploader> -->
  </div>
</template>
<script>
// import Uploader from '../media/uploader.vue'
import CreatVideo from './creat-video.vue'
import CreatImage from './creat-image.vue'
import CreatTitle from './creat-title.vue'
import CreatText from './creat-text.vue'
import CreatIcon from './creat-icon.vue'
import CreatUrl from './creat-url.vue'
export default {
  name: 'creative',
  components: { CreatVideo, CreatImage, CreatTitle, CreatText, CreatIcon, CreatUrl },
  props: {
    data: {
      type: Array
    },
    verify: {
      type: Boolean
    },
    source: {
      type: Array
    }
  },
  computed: {
    creativeClasses() {
      return (item) => {
        let cls = ''
        let def = 'c-creative-hidden'
        if (['ELEMENT_TYPE_VIDEO', 'ELEMENT_TYPE_IMAGE'].includes(item.element_type)) {
          cls = 'c-creative-media'
          def = 'c-creative-enabled'
        } else if (item.name === 'title') {
          cls = 'c-creative-title'
          def = 'c-creative-enabled'
        } else if (['ELEMENT_TYPE_TEXT'].includes(item.element_type) && item.name !== 'title') {
          cls = 'c-creative-text'
          def = 'c-creative-enabled'
        } else if (item.element_type === 'ELEMENT_TYPE_STRUCT') {
          cls = 'c-creative-struct'
          def = 'c-creative-enabled'
        } else if (item.element_type === 'ELEMENT_TYPE_URL') {
          cls = 'c-creative-url'
          def = 'c-creative-enabled'
        } else if (item.element_type === 'ELEMENT_TYPE_ICON') {
          cls = 'c-creative-icon'
          def = 'c-creative-enabled'
        }
        return `${cls} ${def}`
      }
    }
  },
  methods: {
    switchToType(val) {
      if (val === 'ELEMENT_TYPE_IMAGE') return 'image'
      else if (val === 'ELEMENT_TYPE_ICON') return 'image'
      else if (val === 'ELEMENT_TYPE_VIDEO') return 'video'
      else throw new Error('未知的素材类型')
    },
    selectMedia(params) {
      const { name, width, height, size, type } = params
      const uploadType = this.switchToType(type)
      this.uploadModel = true
      this.uploadName = name
      this.uploadType = uploadType
      this.uploadWidth = width
      this.uploadHeight = height
      this.uploadSize = size
    },
    // 选择素材回调
    uploadFileHandle(meta) {
      // 素材大小判断
      const size = meta.size / 1000
      if (this.uploadSize < size) {
        this.$Message.error({
          closable: true,
          duration: 5,
          content: '上传的文件超过限制大小'
        })
        return
      }
      if (this.uploadType === 'image') {
        const url = meta.url
        const index = this.data.findIndex((ret) => ret.name === this.uploadName)
        // 组图方式
        if (index < 0) {
          const sub = this.data.findIndex((ret) => ret.children)
          if (sub < 0) throw new Error('选择素材回调错误')
          const subIdx = this.data[sub].children.findIndex((ret) => ret.name === this.uploadName)
          this.$set(this.data[sub].children[subIdx], this.uploadName, url)
        } else {
          this.$set(this.data[index], this.uploadName, url)
        }
      } else if (this.uploadType === 'video') {
        const id = meta.videoid
        const index = this.data.findIndex((ret) => ret.name === this.uploadName)
        if (index > -1) this.$set(this.data[index], this.uploadName, id)
        // 添加素材源 去重
        const idx = this.source.findIndex((ret) => ret.id === id)
        if (idx < 0) this.source.push(Object.assign({ id }, meta))
      }
      this.uploadModel = false
    },
    // 上传素材完成
    uploadFileComplet({ type, name, size, data }) {
      this.uploadType = this.switchToType(type)
      this.uploadName = name
      this.uploadSize = size
      this.uploadFileHandle(data)
    },
    retVerify(val) {}
  },
  data() {
    return {
      uploadModel: null,
      uploadType: '',
      uploadName: '',
      uploadWidth: 0,
      uploadHeight: 0,
      uploadSize: 0
    }
  }
}
</script>
<style lang='scss' scoped>
.c-creative {
  width: 100%;
  padding: 8px 0 15px 0;

  .c-creative-wrapper {
    width: inherit;
    position: relative;

    .c-creative-hidden {
      opacity: 0;
      z-index: -1;
      position: relative;
    }

    .c-creative-enabled {
      &:after {
        content: '';
        display: block;
        clear: both;
        font-size: 0;
      }

      opacity: 1;
    }

    .c-creative-media {
      display: inline-block;
      margin-right: 6px;

      &:first-child {
        margin-left: 0;
      }
    }

    .c-creative-struct {
      margin-bottom: 24px;
    }

    .c-creative-title,
    .c-creative-text,
    .c-creative-url,
    .c-creative-icon {
      margin-top: 24px;
    }
  }
}
</style>
